var React = require('react');

function MenMVil (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#294B52","d":"M0 0H50V50H0z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M24 10H26V40H24z","transform":"rotate(90 25 25)","key":1}),React.createElement("path",{"fill":"#FFF","d":"M24 -2H26V28H24z","transform":"rotate(90 25 13)","key":2}),React.createElement("path",{"fill":"#FFF","d":"M24 22H26V52H24z","transform":"rotate(90 25 37)","key":3})]));
}

MenMVil.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = MenMVil;

MenMVil.default = MenMVil;
